import PageNotFoundPage from "../../../Common/PageNotFoundPage";
import { getFromLocalStorage } from "../../../utils/webStorage";
import RealTimeStreamingDashboard from "./RealTimeStreamingDashboard";

const RealTimeStreamingDashboardContainer = () => {
  const adminRole = getFromLocalStorage("loginRole");
  return (
    <>
      {adminRole === "SCHOOL ADMIN" || adminRole === "COACH" ? (
        <RealTimeStreamingDashboard />
      ) : (
        <PageNotFoundPage />
      )}
    </>
  );
};

export default RealTimeStreamingDashboardContainer;
